import {
  GET_TYPE_SERVICES_SUCCESS,
  GET_TYPE_SERVICES_FAIL,
  GET_TYPE_SERVICE_PROFILE_SUCCESS,
  GET_TYPE_SERVICE_PROFILE_FAIL,
  ADD_TYPE_SERVICE_SUCCESS,
  ADD_TYPE_SERVICE_FAIL,
  UPDATE_TYPE_SERVICE_SUCCESS,
  UPDATE_TYPE_SERVICE_FAIL,
  DELETE_TYPE_SERVICE_SUCCESS,
  DELETE_TYPE_SERVICE_FAIL,
  DELETE_TYPE_SERVICE,
  ADD_NEW_TYPE_SERVICE,
  UPDATE_TYPE_SERVICE
  
} from "./actionTypes";

const INIT_STATE = {
  data: [],
  vendor_catProfile: {},
  total_page: 0,
  error: {},
  loading:false
};

const type_services = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TYPE_SERVICES_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total_page:action.payload.total_page
      }

    case GET_TYPE_SERVICES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      case ADD_NEW_TYPE_SERVICE:
        return {
          ...state,
          loading:true
        }
    case ADD_TYPE_SERVICE_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        loading:false
      }

    case ADD_TYPE_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_TYPE_SERVICE:
        return {
          ...state,
          loading:true
        }
    case UPDATE_TYPE_SERVICE_SUCCESS:
      return {
        ...state,
        data: state.data.map(vendor_cat =>
          vendor_cat.id.toString() === action.payload.id.toString()
            ? { ...vendor_cat, ...action.payload }
            : vendor_cat
        ),
        loading:false
      }

    case UPDATE_TYPE_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_TYPE_SERVICE:
      return {
        ...state,
        loading:true
      }
    case DELETE_TYPE_SERVICE_SUCCESS:
      return {
        ...state,
        data: state.data.filter(
          vendor_cat => vendor_cat.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_TYPE_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_TYPE_SERVICE_PROFILE_SUCCESS:
      return {
        ...state,
        vendor_catProfile: action.payload,
      }

    case GET_TYPE_SERVICE_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default type_services;
